import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	borderColor: {
		id: 'company-hub.cards-extension.cards.config-panel.border.color',
		defaultMessage: 'Border color',
		description: 'Label text for the border color customization option',
	},
});
